/**
 * i18n config per docs/04_I18N_STRATEGY.md
 * English is the default locale; Bangla remains available via routing + cookie preference.
 */
export const locales = ["bn", "en"] as const;
export type Locale = (typeof locales)[number];

export const defaultLocale: Locale = "en";

export const localeNames: Record<Locale, string> = {
  bn: "বাংলা",
  en: "English",
};

export const LOCALE_COOKIE = "progsity-locale";
